import React, { useContext, useEffect, useState } from 'react'
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext'
import { mapParentChatbotWithSubChatbotPayload, SubChatbot } from '../../../models/axiosModel';
import { Grid, useMediaQuery } from '@mui/material';
import EmptyState from '../../global/emptyState';
import GlobalButton from '../../utility/globalButton/button';
import IconsColor from '../../utility/iconsColor'; 
import emptySubAIChatbot from "../../../assets/images/subAiChatbot/emptySubAIChatbot.png";
import SubAiChatbotTable from './subAiChatbotTable';
import GlobalPopUp from '../../utility/globalPopUp';
import CreateUpdateSubChatbotDialog from './createUpdateSubChatbotDialog'; 
import AddIcon from '@mui/icons-material/Add';
import { useSearchParams } from 'react-router-dom';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import agent from '../../../services/api';
import subChatbotStyle from "../../../assets/styles/componentStyles/subChatbotStyles/subChatbot.module.scss"; 
import globalStyles from "../../../assets/styles/global.module.scss"
import { GenericDataContext, GenericDataContextPayload } from '../../../context/genericDataContext';
import { AIChatbotBreadcrumb, chatbotDetailsBreadcrumb, homeBreadcrumb, subAiChatbotBreadcrumb } from '../../../utils/breadcrumb';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

const SubAiChatbot = () => {


    const { chatBotDetails, GetChatbotDataApi } = useContext(ChatbotContext) as ChatbotContextPayload; 
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload; 
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [subAiChatbotData, setSubAiChatbotData] = useState<SubChatbot[]>([]);
    const [flagCreateUpdateDialog, setFlagCreateUpdateDialog] = useState<boolean>(false);
    const [requestedSubChatbotData, setRequestedSubChatbotData] = useState<mapParentChatbotWithSubChatbotPayload | null>(null); 
    const [tempSubChatbotData, setTempSubChatbotData] = useState<mapParentChatbotWithSubChatbotPayload | null>(null);

    const [deleteChatbotDialog, setDeleteChatbotDialog] = useState<boolean>(false);

    const [searchParams, setSearchParams] = useSearchParams();
    const chatbot_id = searchParams.get('chatbot_id');
    let pathname = window.location.pathname.toLowerCase();
    
    useEffect(() => {
        setSubAiChatbotData(chatBotDetails ? chatBotDetails.sub_chatbot : []); 
        const updatedBreadcrumbs = [
            {...homeBreadcrumb}, 
            AIChatbotBreadcrumb, 
            {...chatbotDetailsBreadcrumb, name: chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot", path: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`}, 
            {...subAiChatbotBreadcrumb, isActive: true}
        ]; 
        setBreadCrumbs(updatedBreadcrumbs);
    }, [chatBotDetails]);

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    } 

    const GetChatbotDataApiCall = async () => {
        setFlagLoading((prevState) =>  ({ ...prevState, flagRoundLoader: true }));
        const res = await GetChatbotDataApi(Number(chatbot_id));
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prevState) =>  ({ ...prevState, flagRoundLoader: false }));
    }
    
    const handleEditSubChatbot = (chatbot: SubChatbot) => {
        const tempPayload = {
            sub_chatbot_id: chatbot.sub_chatbot_id,  
            parent_chatbot_id: Number(chatbot_id),
            chatbot_id: chatbot.chatbot_id,  
            flag_deleted: false,
            sub_chatbot_data: {
                sub_chatbot_data_id: chatbot.sub_chatbot_data.sub_chatbot_data_id,
                sub_chatbot_data_name: chatbot.sub_chatbot_data.sub_chatbot_data_name,
                sub_chatbot_data_purpose: chatbot.sub_chatbot_data.sub_chatbot_data_purpose,
            }
        }
        setRequestedSubChatbotData(tempPayload); 
        setTempSubChatbotData(tempPayload);
        setFlagCreateUpdateDialog(true); 
    }

    const handleDeleteSubChatbot = (chatbot: SubChatbot) => {
        setRequestedSubChatbotData({
            sub_chatbot_id: chatbot.sub_chatbot_id,  
            parent_chatbot_id: Number(chatbot_id),
            chatbot_id: chatbot.chatbot_id,  
            flag_deleted: true,
            sub_chatbot_data: {
                sub_chatbot_data_id: chatbot.sub_chatbot_data.sub_chatbot_data_id,
                sub_chatbot_data_name: chatbot.sub_chatbot_data.sub_chatbot_data_name,
                sub_chatbot_data_purpose: chatbot.sub_chatbot_data.sub_chatbot_data_purpose,
            }
        }); 
        setDeleteChatbotDialog(true);
    } 

    const onClickOfSave = async (payload: mapParentChatbotWithSubChatbotPayload) => {
        setFlagLoading((prevState) =>  ({ ...prevState, flagRoundLoader: true }));
        const res = await agent.mapParentChatbotWithSubChatbot.post(payload);
        if(!(res.status)){
            handleError(res);
        }else{
            await GetChatbotDataApiCall();  
            setRequestedSubChatbotData(null);
            showSuccess(payload.flag_deleted ? "Sub Chatbot Deleted Successfully" : payload.sub_chatbot_id.length > 0 ? "Sub Chatbot Edited Successfully" : "Sub Chatbot Created Successfully")
        }
        setFlagLoading((prevState) =>  ({ ...prevState, flagRoundLoader: false }));
    } 



    return (
        <>

            <GlobalPopUp
                open={flagCreateUpdateDialog}
                onClose={() => { setFlagCreateUpdateDialog(false); setRequestedSubChatbotData(null);}}
                handleClose={() => { setFlagCreateUpdateDialog(false); setRequestedSubChatbotData(null);}}
                flagShowCloseIcon={true}
                paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "700px"}
                paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "750px"}
                borderRadius='10px'
                titlePadding='0px' 
                flagBackdrop
            >
                <CreateUpdateSubChatbotDialog  
                    subAiChatbotData={subAiChatbotData}
                    requestedSubChatbotData={requestedSubChatbotData} 
                    tempSubChatbotData={tempSubChatbotData}
                    setFlagCreateUpdateDialog={setFlagCreateUpdateDialog} 
                    onClickOfSave={onClickOfSave}
                />
            </GlobalPopUp> 

            {deleteChatbotDialog &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to remove ${ subAiChatbotData.find((chatbot: SubChatbot) => chatbot.chatbot_id == requestedSubChatbotData?.chatbot_id)?.chatbot_name || "this"} chatbot`}
                    open={deleteChatbotDialog}
                    onClose={() => { setDeleteChatbotDialog(false) }}
                    onDelete={() => { 
                        if(requestedSubChatbotData) onClickOfSave(requestedSubChatbotData); 
                        setDeleteChatbotDialog(false);
                    }}
                />
            }
            
            <Grid item className={subChatbotStyle.subAiChatbotDataGridItem}>
                <Grid container className={subChatbotStyle.subAiChatbotDataGridContainer}>
                    {subAiChatbotData.length == 0 ? 
                        <Grid item className={globalStyles.fullwidth}>
                            <EmptyState
                                height={'calc(100vh - 130px)'}
                                pageIcon={<img alt="icon" src={emptySubAIChatbot} className={subChatbotStyle.emptySubAIChatbotIcon} />}
                                pageSubText={"No Sub Chatbot Created Yet"}
                                primaryActionBtn={<GlobalButton
                                    buttonText={"Add Sub Chatbot"}
                                    className='primaryButtonStyle'
                                    sx={{ width: "200px" }}
                                    startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor="#fff" />}
                                    onClick={() => { setFlagCreateUpdateDialog(true); }}
                                />}
                            />
                        </Grid>
                        : 
                        <>  
                            <Grid item xs={12}>
                                <Grid container className={subChatbotStyle.addSubChatbotBtnContainer}>
                                    <GlobalButton
                                        buttonText="Add Sub Chatbot" 
                                        startIcon={<AddIcon />}
                                        className='primaryButtonStyle' 
                                        onClick={() => setFlagCreateUpdateDialog(true)}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className={globalStyles.fullwidth}>
                                <SubAiChatbotTable
                                    subAiChatbotData={subAiChatbotData} 
                                    handleEditSubChatbot={handleEditSubChatbot} 
                                    handleDeleteSubChatbot={handleDeleteSubChatbot}
                                />
                            </Grid>
                        </>
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default SubAiChatbot
